// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xl_a bhi_a bhi_x","StrollerDetailRating__muted":"xl_b bhi_fm"};